// extracted by mini-css-extract-plugin
export default {"btn":"ratingInput_btn__jUa47","ratingInputContainer":"ratingInput_ratingInputContainer__4sh-s"};